// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3KfrL","checkboxCol":"Table_checkboxCol__3SOrj","emailCol":"Table_emailCol__3sFiW","actionCol":"Table_actionCol__3Be_8"};